import React, { useEffect, useState } from "react";
import { Button, Input, Select, Spin } from "antd";
import {
  fetchBBPS3Bill,
  getBBPS3BillerInfo,
  getBBPS3Operator,
  payBBPS3Bill,
} from "../../../ApiServices/Apifun";

// import { BBPS } from "../../../../Assets/BBPS";
// import {
//   fetchEkoBill,
//   getEkoBbpsformParams,
//   getEkoBbpsOperator,
//   payEkoBill,
// } from "../EkoEndpoint";
import ReportDrawer from "../../../Common/ReportDrawer";
import { getLocalStorageItem, filterOption, panPattern } from "../../../Utils";
import Content from "../../../Common/ReceiptContent";
import { BBPS } from "../../../Assets/BBPS";
import { Images } from "../../../Controller";

const BillPayment3 = (props) => {
  const { type, selection, service_id } = props;
  const [operators, setOperators] = useState([]);
  const [selectLoading, setSelectLoading] = useState(false);
  const [Btnloading, setBtnLoading] = useState(false);
  const [getFieldsLoader, setGetFieldsLoader] = useState(false);
  const [AllOerators, setAllOperators] = useState([]);
  const [billDetail, setBillDetail] = useState({});
  const [quickPay, setquickPay] = useState("N");
  const [selectedOperator, setselectedOperator] = useState(null);
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [PaybillResult, setPaybillResult] = useState({
    data: null,
    transaction_id: null,
  });
  const [renderField, setRenderField] = useState([]);
  const [disableAmount, setDisableAmount] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [isfetch, setIsFetch] = useState(0);
  const [disableOperatorField, setDisableOperatorField] = useState(false);
  const [BtnState, setBtnState] = useState("");
  const [showAmount, setShowAmount] = useState(false);
  const [fields, setFields] = useState([]);
  const [amount, setamount] = useState("0");
  const [billerName, setBillerName] = useState("");
  const [billerMobile, setBillerMobile] = useState("");
  const [billerPan, setBillerPan] = useState("");
  const [panError, setPanError] = useState("");
  // state for API field structure
  const [paramFields, setParamFields] = useState([]);

  // state for user-entered values
  const [fieldValues, setFieldValues] = useState({});

  useEffect(() => {
    setselectedOperator(null);
    setOperators([]);
    setRenderField([]);
    setOpenReceiptDrawer(false);
    setPaybillResult({ data: null, transaction_id: null });
    setamount("");
    setBillDetail({});
    setDisableOperatorField(false);
    setBtnLoading(false);
    setDisableAmount(false);
    setSelectLoading(false);
    setShowDetail(false);
    setShowAmount(false);
    setFields([]);
    setGetFieldsLoader(false);
    setAllOperators({});
  }, [selection]);
  const handlePanChange = (e) => {
    let value = e.target.value.toUpperCase();

    if (!/^[A-Z0-9]*$/.test(value)) return;

    if (value.length > 10) return;

    setBillerPan(value);

    if (value.length === 10) {
      if (!panPattern.test(value)) {
        setPanError("Invalid PAN format");
      } else {
        setPanError("");
      }
    } else {
      setPanError("");
    }
  };

  const getAllOperators = () => {
    setSelectLoading(true);
    setDisableOperatorField(true);
    getBBPS3Operator(`${selection}`)
      .then((res) => {
        if (res.status) {
          setAllOperators(res.data.data);
          setOperators(
            res.data?.data.map((item, index) => {
              return {
                label: item.blr_name,
                value: item.blr_id,
                key: index,
              };
            }),
          );
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setSelectLoading(false);
        setDisableOperatorField(false);
      });
  };

  useEffect(() => {
    getAllOperators();
  }, [type]);

  useEffect(() => {
    if (selectedOperator) {
      setShowDetail(false);
      setGetFieldsLoader(true);

      getBBPS3BillerInfo(`?billerId=${selectedOperator}`)
        .then((res) => {
          if (res.status) {
            const paramsList = res.data?.data?.flatMap((i) =>
              i.billerInputParams?.flatMap((param) => param.paramsList || []),
            );

            if (Array.isArray(paramsList) && paramsList.length > 0) {
              console.log(paramsList.length, "length of info");

              setParamFields(paramsList);

              // Extract only the paramName values
              const fieldNames = paramsList.map((item) => item);

              console.log(fieldNames, "Extracted Field Names");

              setFields(fieldNames);
              setRenderField(res.data);
            }
          }
        })
        .catch((err) => console.log(err))
        .finally(() => setGetFieldsLoader(false));

      const checktype = AllOerators.find(
        (item) => item?.blr_id === selectedOperator,
      )?.view_bill_status;

      setIsFetch(checktype);
      checktype === 1 ? setBtnState("Pay Bill") : setBtnState("Fetch Bill");
    }
  }, [selectedOperator]);
  console.log(type, "amount", selection);
  // useEffect(() => {
  //   if (selectedOperator) {
  //     setShowDetail(false);
  //     setGetFieldsLoader(true);
  //     let formdata = new FormData();
  //     formdata.append("blr_id", selectedOperator);
  //     getBillerInfo(formdata)
  //       .then((res) => {
  //         if (res.status) {
  //           setRenderField(res.data);
  //           // const objectFromDataArray = res.data.reduce((obj, item) => {
  //           //   obj[item.param_name] = "";
  //           //   return obj;
  //           // }, {});
  //           const objectFromDataArray = res.data?.billerInputParams?.paramsList;
  //           setFields(objectFromDataArray);
  //         }
  //       })
  //       .catch((err) => console.log(err))
  //       .finally(() => setGetFieldsLoader(false));

  //     const checktype = AllOerators.filter(
  //       (item, index) => item?.blr_id === selectedOperator
  //     )[0]?.view_bill_status;
  //     setIsFetch(checktype);
  //     checktype === 1 ? setBtnState("Pay Bill") : setBtnState("Fetch Bill");
  //     // setIsfetch(
  //     //   AllOerators.filter(
  //     //     (item, index) => item?.blr_id === selectedOperator
  //     //   )[0]?.is_fetch
  //     // );
  //   }
  // }, [selectedOperator]);

  const handleChange = (e, type, min, max) => {
    const { name, value } = e.target;
    let updatedValue = value || "";

    if (type === "NUMERIC") {
      updatedValue = value.replace(/[^0-9]/g, "");
    }

    if (max) {
      updatedValue = updatedValue.slice(0, Number(max));
    }

    setFieldValues((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  const handeBtnSubmit = () => {
    setBtnLoading(true);
    setDisableOperatorField(true);
    if (BtnState === "Fetch Bill") {
      const formdata = new FormData();
      formdata.append("biller_id", selectedOperator);
      formdata.append("customerMobile", billerMobile);
      formdata.append("service_id", service_id);

      paramFields.forEach((field, index) => {
        const paramName = field.paramName;
        const paramValue = fieldValues[paramName] || "";

        formdata.append(`inputParams[${index}][paramName]`, paramName);
        formdata.append(`inputParams[${index}][paramValue]`, paramValue);
      });
      fetchBBPS3Bill(formdata, type)
        .then((res) => {
          if (res.status) {
            setShowDetail(true);
            setBillDetail(res.data);
            const amountFromResponse = res.data?.amount
              ? (res.data.amount / 100).toFixed(2)
              : "0";

            setamount(amountFromResponse);
            setquickPay("Y");
            setBtnState("Pay Bill");
            // setDisableAmount(true);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setBtnLoading(false);
          setDisableOperatorField(false);
        });
    } else {
      const formdata = new FormData();
      formdata.append("customer_mobile", billerMobile);
      formdata.append("biller_id", selectedOperator);
      formdata.append("service_id", service_id);
      const amountInPaise = Math.round(Number(amount || 0) * 100);

      formdata.append("bill_amount", amountInPaise);
      // formdata.append("bill_amount", billDetail.amount);
      formdata.append("bill_date", billDetail.bill_date);
      formdata.append("customer_name", billDetail.account_holder_name);
      formdata.append("due_date", billDetail.due_date);

      paramFields.forEach((field, index) => {
        const paramName = field.paramName;
        const paramValue = fieldValues[paramName] || "";

        formdata.append(`inputParams[${index}][paramName]`, paramName);
        formdata.append(`inputParams[${index}][paramValue]`, paramValue);
      });

      payBBPS3Bill(formdata, type)
        .then((res) => {
          if (res.status) {
            setPaybillResult({
              data: {
                "Biller Name": res.data.biller_name,
                Amount: res.data.amount,
                "Payment Status":
                  res.data.payment_status === 2
                    ? "Failed"
                    : res.data.payment_status === 0
                      ? "Pending"
                      : "Success",
              },
              transaction_id: res.data.transaction_id,
            });
            setOpenReceiptDrawer(true);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setBtnLoading(false);
          setDisableOperatorField(false);
        });
    }
  };
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 w place-items-start gap-3">
        <Spin spinning={getFieldsLoader}>
          <div className="prepaid bg-white w-full shadow-normal rounded-3xl   p-5">
            <div className="flex justify-between items-center">
              <p className="font-bold capitalize text-[15px] mb-2">
                {selection} Payment
              </p>
            </div>
            <Spin spinning={selectLoading}>
              <div className="selectionFields ">
                <div>
                  <p className={`required text-textGray mb-2`}>
                    Select Operator
                  </p>
                  <Select
                    showSearch
                    placeholder="Select an operator"
                    filterOption={filterOption}
                    value={selectedOperator}
                    loading={selectLoading}
                    disabled={disableOperatorField}
                    onChange={(val) => {
                      setselectedOperator(val);
                      setShowDetail(true);
                    }}
                    className="w-full mb-2 "
                    options={operators}
                  />
                </div>
                {/* {renderField.length !== 0
                  ? renderField?.map((item, index) => {
                      return ( */}
                <div>
                  {Array.isArray(paramFields) &&
                    paramFields.length > 0 &&
                    paramFields.map((i, id) => (
                      <div key={id}>
                        <p className="required capitalize text-textGray mt-2 text-xs mb-2">
                          {i.paramName}
                        </p>
                        <input
                          name={i.paramName}
                          placeholder={`Enter ${i.paramName}`}
                          value={fieldValues[i.paramName] || ""}
                          onChange={(e) =>
                            handleChange(
                              e,
                              i.dataType,
                              i.minLength,
                              i.maxLength,
                            )
                          }
                          minLength={Number(i.minLength)}
                          maxLength={Number(i.maxLength)}
                          type="text"
                          className="outline-none text-xs border w-full border-gray-200 focus:border-primary h-9 px-2"
                        />
                      </div>
                    ))}

                  {/* <p className={`required capitalize text-textGray mb-2`}>
                    Name
                  </p>
                  <input
                    value={billerName}
                    min={1}
                    // disabled={disablebillerName && type !== "fasttag"}
                    onChange={(e) => setBillerName(e.target.value)}
                    type="string"
                    className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                  /> */}
                  <p className={`required capitalize text-textGray mb-2`}>
                    Mobile Number
                  </p>
                  <input
                    value={billerMobile}
                    min={1}
                    // disabled={disableAmount && type !== "fasttag"}
                    onChange={(e) => setBillerMobile(e.target.value)}
                    type="number"
                    className="outline-none text-xs border w-full border-gray-200 focus:border-primary  h-9 px-2 "
                  />
                  {/* {BtnState === "Pay Bill" && Number(amount) > 50000 && (
                    <>
                      <p className="capitalize text-textGray mb-2">
                        PAN Number <span className="text-red-500">*</span>
                      </p>

                      <input
                        value={billerPan}
                        onChange={handlePanChange}
                        placeholder="ABCDE1234F"
                        className="outline-none text-xs border w-full border-gray-200 focus:border-primary h-9 px-2 uppercase"
                      />

                      {panError && (
                        <p className="text-red-500 text-xs mt-1">{panError}</p>
                      )}
                    </>
                  )} */}
                </div>

                {showDetail && Object.keys(billDetail).length !== 0 && (
                  <>
                    <div>
                      <p className="required capitalize text-textGray mb-2">
                        Amount
                      </p>
                      <Input
                        type="text"
                        inputMode="decimal" // mobile keyboards show numbers
                        value={amount ?? ""} // ensure always a string
                        onChange={(e) => {
                          const val = e.target.value;

                          // Allow empty value (so you can delete)
                          // Allow digits and one decimal point
                          if (val === "" || /^[0-9]*\.?[0-9]*$/.test(val)) {
                            setamount(val);
                          }
                        }}
                        className="outline-none text-xs border w-full border-gray-200 focus:border-primary h-9 px-2"
                      />
                    </div>

                    <div className="grid mt-2 grid-cols-1 border border-primary p-2 rounded-md font-medium text-xs bg-bsgray300 sm:grid-cols-2 gap-2 place-items-start">
                      <p>Name : {billDetail.account_holder_name || "-"}</p>
                      {type !== "fasttag" && (
                        <>
                          <p>
                            Amount :{" "}
                            {(billDetail.amount / 100).toFixed(2) || "-"} Rs.
                          </p>
                          <p>Bill Date : {billDetail.bill_date || "-"}</p>
                          <p>Due Date : {billDetail.due_date || "-"}</p>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </Spin>
            {selectedOperator && (
              <div className="mt-2">
                <Button
                  disabled={Object.values(fields).some((value) => value === "")}
                  loading={Btnloading}
                  onClick={handeBtnSubmit}
                  className="bg-primary w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
                >
                  {/* {isFetch === 1 ? "Fetch Bill" : "Pay Bill"} */}
                  {BtnState}
                </Button>
              </div>
            )}
          </div>
        </Spin>
      </div>
      {openReceiptDrawer && (
        <ReportDrawer
          title={"BBPS 3 Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content data={PaybillResult} />}
        />
      )}
    </>
  );
};

export default BillPayment3;
